import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import ServiceName from '../../../../entities/ServiceName';
import ShowService from '../../../../shared_components/Info/ShowService/ShowService';
import SalePriceTableMoneyRowProperties from './SalePriceTableMoneyRowProperties';
import ShowEditMoneySalePrice from '../../../../shared_components/InfoEditables/ShowEditMoneySalePrice/ShowEditMoneySalePrice';
import Currency from '../../../../entities/Currency';
import { useStyles } from '../../SalePrices.style';


const SalePriceTableMoneyRow: React.FC<SalePriceTableMoneyRowProperties> = ({
    salePrices, onUpdate
                                                  }) => {

    const classes = useStyles();

    const onUpdateValue = () => {
        onUpdate();
    }

    const currencies = [Currency.DOLLAR, Currency.MLC, Currency.MN];

    return (
        <>
        <TableRow hover role="checkbox" tabIndex={-1} key={'row.id'}>
            <TableCell key={`column.id`} align={'right'}>
                <ShowService service={ServiceName.MONEY_DELIVERY}/>
            </TableCell>
        </TableRow>
            <TableRow>
                
                {salePrices
                    .flatMap(sp => sp.moneySalePrices)
                    ?.slice()
                    .sort((a, b) => a.fromValue - b.fromValue)
                    .map((price) => {
                    return (
                        <TableCell key={price.id} align={'left'}>
                            <div className={classes.values_container}>
                                {currencies.map((currency: Currency, i) => {
                                    const salePriceCurrency = price?.salePriceByCurrency.find(b => b.currency === currency);
                                    return <ShowEditMoneySalePrice
                                        value={salePriceCurrency ? salePriceCurrency.salePrice : 0}
                                        isPercentage={salePriceCurrency ? salePriceCurrency.isPercentage : true}
                                        currency={currency}
                                        salePriceId={price.id}
                                        serviceFeeId={price.id}
                                        onSave={onUpdateValue}/>
                                })}
                            </div>
                        </TableCell>
                    );
                })}
            </TableRow>
        </>
    )
}

export default SalePriceTableMoneyRow;
